/*
 * @Author: 李明明
 * @Date: 2022-07-28 09:42:27
 * @LastEditTime: 2023-07-28 14:07:29
 * @LastEditors: 李明明
 * @Description: 子应用路由文件
 * @FilePath: /ykt-micro-main/src/micros/app.js
 * 代码版权方：'政府采购信息网'
 */

import router from "@/router";

let apps = [];
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV == "development") {
  apps = [
    /**
     * name: 微应用名称 - 具有唯一性
     * entry: 微应用入口 - 通过该地址加载微应用
     * container: 微应用挂载节点 - 微应用加载完成后将挂载在该节点上
     * activeRule: 微应用触发的路由规则 - 触发路由规则后将加载该微应用
     */
    // 我的课程子应用
    {
      name: "course",
      entry: "//localhost:9001",
      container: "#micro-container",
      activeRule: "#/course",
      props: {
        router: router,
      },
    },
    // 我的订单子应用
    {
      name: "order",
      entry: "//localhost:9002",
      container: "#micro-container",
      activeRule: "#/order",
      props: {
        router: router,
      },
    },
    // 参培学员信息子应用
    {
      name: "trainInfo",
      entry: "//localhost:9003",
      container: "#micro-container",
      activeRule: "#/train_info",
      props: {
        router: router,
      },
    },
    // 学员学员子应用
    {
      name: "studentManage",
      entry: "//localhost:9004",
      container: "#micro-container",
      activeRule: "#/student_management",
      props: {
        router: router,
      },
    },
    // 成绩查询子应用
    {
      name: "score",
      entry: "//localhost:9005",
      container: "#micro-container",
      activeRule: "#/result_list",
      props: {
        router: router,
      },
    },
    // 报名子应用
    {
      name: "enroll",
      entry: "//localhost:9006",
      container: "#micro-container",
      activeRule: "#/sign_detail",
      props: {
        router: router,
      },
    },
    // 考试子应用
    {
      name: "exam",
      entry: "//localhost:9007",
      container: "#micro-container2",
      activeRule: "#/exam",
      props: {
        router: router,
      },
    },
    // 我的证书子应用
    {
      name: "zs",
      entry: "//localhost:9008",
      container: "#micro-container",
      activeRule: "#/zs",
      props: {
        router: router,
      },
    },
    // 非公共头尾独立子应用
    {
      name: "alone",
      entry: "//localhost:9009",
      container: "#micro-container2",
      activeRule: "#/alone",
      props: {
        router: router,
      },
    },
    // 帮助中心
    {
      name: "help",
      entry: "//localhost:9010",
      container: "#micro-container",
      activeRule: "#/help",
      props: {
        router: router,
      },
    },
    // 消息中心
    {
      name: "message",
      entry: "//localhost:9011",
      container: "#micro-container",
      activeRule: "#/message",
      props: {
        router: router,
      },
    },
    // 考试列表
    {
      name: "exam_list",
      entry: "//localhost:9012",
      container: "#micro-container",
      activeRule: "#/exam_list",
      props: {
        router: router,
      },
    },
  ];
}else{
  apps = [
    /**
     * name: 微应用名称 - 具有唯一性
     * entry: 微应用入口 - 通过该地址加载微应用
     * container: 微应用挂载节点 - 微应用加载完成后将挂载在该节点上
     * activeRule: 微应用触发的路由规则 - 触发路由规则后将加载该微应用
     */
    // 我的课程子应用
    {
      name: "course",
      entry: "/child/ykt-course/",
      container: "#micro-container",
      activeRule: "#/course",
      props: {
        router: router,
      },
    },
    // 我的订单子应用
    
    {
      name: "order",
      entry: "/child/ykt-order/",
      container: "#micro-container",
      activeRule: '#/order',
      props: {
        router: router,
      },
    },
    // 学员子应用
    {
      name: "trainInfo",
      entry: "/child/ykt-student-info/",
      container: "#micro-container",
      activeRule: "#/train_info",
      props: {
        router: router,
      },
    },
    // 参培学员子应用
    {
      name: "studentManage",
      entry: "/child/ykt-student-management/",
      container: "#micro-container",
      activeRule: "#/student_management",
      props: {
        router: router,
      },
    },
    // 成绩查询子应用
    {
      name: "score",
      entry: "/child/ykt-score/",
      container: "#micro-container",
      activeRule: "#/result_list",
      props: {
        router: router,
      },
    },
    // 报名子应用
    {
      name: "enroll",
      entry: "/child/ykt-enroll/",
      container: "#micro-container",
      activeRule: "#/sign_detail",
      props: {
        router: router,
      },
    },
    // 考试子应用
    {
      name: "exam",
      entry: "/child/ykt-exam/",
      container: "#micro-container2",
      activeRule: "#/exam",
      props: {
        router: router,
      },
    },
    // 我的证书子应用
    {
      name: "zs",
      entry: "/child/ykt-zs",
      container: "#micro-container",
      activeRule: "#/zs",
      props: {
        router: router,
      },
    },
    // 非公共头尾独立子应用
    {
      name: "alone",
      entry: "/child/ykt-alone/",
      container: "#micro-container2",
      activeRule: "#/alone",
      props: {
        router: router,
      },
    },
    // 帮助中心
    {
      name: "help",
      entry: "/child/ykt-help/",
      container: "#micro-container",
      activeRule: "#/help",
      props: {
        router: router,
      },
    },
    // 消息中心
    {
      name: "message",
      entry: "/child/ykt-message/",
      container: "#micro-container",
      activeRule: "#/message",
      props: {
        router: router,
      },
    },
    // 考试列表
    {
      name: "exam_list",
      entry: "/child/ykt-exam-list/",
      container: "#micro-container",
      activeRule: "#/exam_list",
      props: {
        router: router,
      },
    },
  ];
}

export default apps;
